import React, { useCallback } from 'react'
import { useOpenDeviceSelector } from '../../../../Devices/components/DeviceSelector/DeviceSelector'

import { useParticipant } from '../../../../webrtc/webRTCRoom'
import { toggleVideo } from '../../../../webrtc/blocs/videoMuting'
import {
  enableParticipantAudio,
  toggleParticipantAudio,
} from '../../../../webrtc/blocs/audioMuting'

import { MuteAudioTrigger } from './MuteAudioTrigger/MuteAudioTrigger'
import { MuteVideoTrigger } from './MuteVideoTrigger/MuteVideoTrigger'
import { changeSelectedDevices } from '../../../../Devices/useDevices'

import './ParticipantMutingTriggers.scss'

interface ParticipantMutingTriggersProps {
  participantId: number
  isProducer: boolean
}

const ParticipantMutingTriggers = ({
  participantId,
  isProducer,
}: ParticipantMutingTriggersProps) => {
  const openDeviceSelector = useOpenDeviceSelector()
  const participant = useParticipant(participantId)

  const toggleAudio = useCallback(async () => {
    if (participant?.isLocal && !participant.tracks.cameraAudio) {
      const devicesSelected = await openDeviceSelector()
      changeSelectedDevices(devicesSelected)
      enableParticipantAudio(participantId)
    } else {
      await toggleParticipantAudio(participantId)
    }
  }, [
    openDeviceSelector,
    participant?.isLocal,
    participant?.tracks.cameraAudio,
    participantId,
  ])

  const onMuteVideoTriggerClick = useCallback(async () => {
    if (participant?.isLocal && !participant.tracks.camera) {
      const devicesSelected = await openDeviceSelector()
      changeSelectedDevices(devicesSelected)
    } else {
      await toggleVideo()
    }
  }, [openDeviceSelector, participant?.isLocal, participant?.tracks.camera])

  if (!participant) return null

  return (
    <>
      <MuteAudioTrigger
        participantId={participantId}
        isMutingAllowed={participant.isLocal || isProducer}
        isLocal={participant.isLocal}
        isMuted={!participant.tracks.cameraAudio?.isEnabled}
        toggleAudio={toggleAudio}
      />
      {participant.isLocal && (
        <MuteVideoTrigger
          isMuted={!participant.tracks.camera?.isEnabled}
          toggleVideo={onMuteVideoTriggerClick}
        />
      )}
    </>
  )
}

export { ParticipantMutingTriggers }
